import * as toastr from 'toastr';

export enum ToastrTypes {
    Success,
    Info,
    Warning,
    Error
}

export class xToastr {

    public static ShowToast(type: ToastrTypes, title: string, message: string, options: any = "", positionClass: string = "toast-top-center") {

        if (options != "") {
            toastr.options = options;
        } else {
            //default options
            toastr.options = {
                closeButton: true,
                progressBar: true,
                debug: true,
                preventDuplicates: true,
                positionClass: positionClass,
                onclick: null,
                showDuration: 400,
                hideDuration: 1000,
                timeOut: 5000,
                extendedTimeOut: 1000,
                showEasing: "swing",
                hideEasing: "linear",
                showMethod: "fadeIn",
                hideMethod: "fadeOut"
            };
        }

        switch (type) {

            case ToastrTypes.Info:
                toastr.info(message, title);
                break;

            case ToastrTypes.Error:
                toastr.error(message, title);
                break;

            case ToastrTypes.Success:
                toastr.success(message, title);
                break;

            case ToastrTypes.Warning:
                toastr.warning(message, title);
                break;

            default:
                toastr.error(message, title);
        }

    }
}